import './RegStyle.css';
import Footer from '../Footer';
import Header from '../Header';


function RegEnd(props) {

	return (
		<>
			<Header />
			<div className="iol-lrcp-wrapper row reg-row">
				<div className="iol-lrcp-text-wrapper col-xl-6">
					<h1 className="large-title fucsia-text">Registrazione inviata</h1>
					<p className="heading-5">Riceverai via mail le istruzioni per poter completare il processo di registrazioni e poter accedere alla tua area riservata. Ti ringraziamo per la fiducia accordataci.</p>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default RegEnd;
